enum Portal {
  CompanyPortal = 'company_portal',
  Experience = 'experience',
  Onsite = 'onsite-app',
}

export default Portal;
